import { render } from "./MultiLimitedComponent.vue?vue&type=template&id=3c6a48d8&scoped=true&ts=true"
import script from "./MultiLimitedComponent.vue?vue&type=script&lang=ts"
export * from "./MultiLimitedComponent.vue?vue&type=script&lang=ts"

import "./MultiLimitedComponent.vue?vue&type=style&index=0&id=3c6a48d8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/SurveyPublic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6a48d8"]])

export default __exports__